import axios from "axios";
import { showAlert } from "./alerts";

export const stripe = async (tourId) => {
  try {
    const { data } = await axios({
      method: "POST",
      url: `/api/v1/bookings/checkout-session/${tourId}`,
    });

    return data.session.url;
  } catch (error) {
    showAlert("error", error.message);
  }
};
